export const LAST_SEEN_CONSTANTS = {
  ONLINE_NOW_MINUTE_DIFFERENCE: 15,
  LAST_SEEN_IN_FEW_DAYS_CUTOFF: 7,
}
